module.exports = __webpack_public_path__ + "img/page-11.dc01c20e.jpg";